"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUipData = exports.UipDataProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _domainServices = require("@site/domain-services");
var _uip = require("./utils/uip");
var _ComponentDataProvider = require("./ComponentDataProvider");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const UipDataContext = /*#__PURE__*/(0, _react.createContext)();
const UipDataProvider = props => {
  const {
    overrideProps
  } = (0, _ComponentDataProvider.useComponentDataProvider)();
  const {
    children,
    insightTypes = ['favorites', 'history'],
    plid = 1,
    urlOverride = 'godaddy.com',
    fetchedFavoritesDomainsList,
    fetchedFavoritesParsedData,
    fetchedHistoryDomainsList,
    extraFavoritesToggleHandler = () => {},
    onFavoritesToggleError = () => {}
  } = {
    ...props,
    ...overrideProps
  };
  const [favoritesDomainsList, setFavoritesDomainsList] = (0, _react.useState)(fetchedFavoritesDomainsList || window?.serp?.favorites?.domainsList);
  const [favoritesParsedData, setFavoritesParsedData] = (0, _react.useState)(fetchedFavoritesParsedData || window?.serp?.favorites?.parsedData);
  const [historyDomainsList, setHistoryDomainsList] = (0, _react.useState)(fetchedHistoryDomainsList);
  const insightNameMap = {
    favorites: 'favorite_product_array',
    history: 'search_history_array'
  };
  const addFavoriteToUip = ({
    domainName,
    availability
  }) => {
    const newDomainsList = [domainName, ...favoritesDomainsList];
    (0, _domainServices.addDataToUipMutate)({
      domainName,
      plid,
      urlOverride,
      insightName: insightNameMap.favorites,
      availability,
      onError: onFavoritesToggleError
    });
    setFavoritesDomainsList(newDomainsList);
    extraFavoritesToggleHandler?.(newDomainsList);
    window.serp = {
      ...window.serp,
      favorites: {
        ...window.serp?.favorites,
        domainsList: newDomainsList,
        isSynched: false
      }
    };
  };
  const removeFavoriteFromUip = ({
    dateAdded,
    domainName,
    availability
  }) => {
    const newDomainsList = favoritesDomainsList.filter(favoriteDomain => favoriteDomain !== domainName);
    (0, _domainServices.removeDataFromUipMutate)({
      dateAdded,
      domainName,
      plid,
      urlOverride,
      insightName: insightNameMap.favorites,
      availability
    });
    setFavoritesDomainsList(newDomainsList);
    extraFavoritesToggleHandler?.(newDomainsList);
    window.serp = {
      ...window.serp,
      favorites: {
        ...window.serp?.favorites,
        domainsList: newDomainsList,
        isSynched: false
      }
    };
  };
  const fetchDataFromQuery = () => {
    const targetDataString = insightTypes.map(type => insightNameMap[type]).join(',');
    (0, _domainServices.uipGraphQlQuery)({
      targetData: targetDataString,
      plid,
      urlOverride
    }).then(uipApiData => {
      const {
        favoritesList,
        historyList,
        favoritesParsedUipData
      } = (0, _uip.getDataFromUipResponse)(uipApiData);
      if (insightTypes.includes('favorites')) {
        setFavoritesDomainsList(favoritesList);
        setFavoritesParsedData(favoritesParsedUipData);
      }
      if (insightTypes.includes('history')) {
        setHistoryDomainsList(historyList);
      }
      window.serp = {
        ...window.serp,
        favorites: {
          domainsList: favoritesList,
          parsedData: favoritesParsedUipData,
          isSynched: true
        }
      };
    });
  };
  (0, _react.useEffect)(() => {
    fetchedFavoritesDomainsList?.length && setFavoritesDomainsList(fetchedFavoritesDomainsList);
    fetchedFavoritesParsedData?.length && setFavoritesParsedData(fetchedFavoritesParsedData);
    fetchedHistoryDomainsList?.length && setHistoryDomainsList(fetchedHistoryDomainsList);
  }, [fetchedFavoritesDomainsList, fetchedHistoryDomainsList]);
  (0, _react.useEffect)(() => {
    const shouldFetchFavorites = insightTypes.includes('favorites') && !favoritesDomainsList;
    const shouldFetchHistory = insightTypes.includes('history') && !historyDomainsList;
    if (shouldFetchFavorites || shouldFetchHistory) {
      fetchDataFromQuery();
    }
  }, [favoritesDomainsList, historyDomainsList]);
  (0, _react.useEffect)(() => {
    // initial fetch when insightTypes includes favorites and favorites cache is not synched
    // OR when insightTypes includes history and no fetched history domains list being passed in
    const favoritesCacheExistsButNotSynched = window.serp?.favorites && !window.serp?.favorites.isSynched;
    const favoritesIncludedAndUnsynched = insightTypes.includes('favorites') && favoritesCacheExistsButNotSynched;
    if (favoritesIncludedAndUnsynched) {
      fetchDataFromQuery();
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(UipDataContext.Provider, {
    value: {
      favoritesDomainsList,
      favoritesParsedData,
      addFavoriteToUip,
      removeFavoriteFromUip,
      historyDomainsList
    }
  }, children);
};
exports.UipDataProvider = UipDataProvider;
UipDataProvider.propTypes = {
  plid: _propTypes.default.number,
  urlOverride: _propTypes.default.string,
  fetchedFavoritesDomainsList: _propTypes.default.array,
  fetchedFavoritesParsedData: _propTypes.default.array,
  fetchedHistoryDomainsList: _propTypes.default.array,
  extraFavoritesToggleHandler: _propTypes.default.func,
  onFavoritesToggleError: _propTypes.default.func,
  children: _propTypes.default.node
};
const useUipData = () => {
  const {
    favoritesDomainsList,
    favoritesParsedData,
    addFavoriteToUip,
    removeFavoriteFromUip,
    historyDomainsList
  } = (0, _react.useContext)(UipDataContext) || {};
  return {
    favoritesDomainsList,
    favoritesParsedData,
    addFavoriteToUip,
    removeFavoriteFromUip,
    historyDomainsList
  };
};
exports.useUipData = useUipData;